(function () {
  const LOG_PREFIX = '[UFL CART]';

  // === UFL Cart Drawer Controls ===
  function openCartDrawer() {
    const cart = document.getElementById("ufl-cart");
    if (cart) {
      cart.classList.remove("ufl-hidden");
      console.log(`${LOG_PREFIX} Opened UFL cart drawer`);
    }
    clearThemeDrawerArtifacts();
  }

  window.uflCloseCart = () => {
    document.getElementById("ufl-cart")?.classList.add("ufl-hidden");
  };

  function clearThemeDrawerArtifacts() {
    document.body.classList.remove(
      "js-drawer-open", "cart-drawer-open", "drawer-open",
      "overflow-hidden", "cart-open", "open", "is-active", "lock-scroll"
    );
    document.body.style.cssText = '';

    document.querySelectorAll(
      "#CartDrawer, .cart-drawer, [data-cart-drawer], .cart-drawer__overlay, .drawer__overlay, .modal-backdrop, .bg-overlay, .overlay, .drawer__underlay"
    ).forEach(el => el.remove());
  }

  async function fetchUpdatedCartHTML() {
    const res = await fetch(window.location.href);
    const html = await res.text();
    return new DOMParser().parseFromString(html, 'text/html');
  }

  async function refreshCartElements() {
    const htmlDoc = await fetchUpdatedCartHTML();

    ['#ufl-cart-items', '[data-cart-count]', '[data-cart-subtotal]'].forEach(sel => {
      const newEl = htmlDoc.querySelector(sel);
      const oldEl = document.querySelector(sel);
      if (newEl && oldEl) oldEl.replaceWith(newEl);
    });

    openCartDrawer();
  }

  function hijackCartActions() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      if (form.dataset.uflBound) return;
      form.dataset.uflBound = "true";
      form.addEventListener("submit", async (e) => {
        e.preventDefault();
        e.stopPropagation();
        const formData = new FormData(form);
        await fetch("/cart/add.js", { method: "POST", body: formData });
        refreshCartElements();
      });
    });

    document.querySelectorAll('a[href="/cart"], button[aria-controls*="cart"]').forEach(el => {
      if (el.dataset.uflBound) return;
      el.dataset.uflBound = "true";
      el.removeAttribute("aria-controls");
      el.removeAttribute("aria-expanded");
      el.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        openCartDrawer();
      });
    });

    document.querySelectorAll('[href="/checkout"], [name="checkout"]').forEach(btn => {
      if (btn.dataset.uflBound) return;
      btn.dataset.uflBound = "true";
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = "/checkout";
      });
    });
  }

  function enforceAriaExpandedFalse() {
    document.querySelectorAll('[aria-controls*="cart"]').forEach(el => {
      new MutationObserver(muts => {
        muts.forEach(m => {
          if (m.attributeName === 'aria-expanded') {
            el.setAttribute('aria-expanded', 'false');
          }
        });
      }).observe(el, { attributes: true });
    });
  }

  function nullifyShopifyEvents() {
    if (window.Shopify) {
      Shopify.onItemAdded = () => {};
      Shopify.onCartUpdate = () => {};
      Shopify.onCartChanged = () => {};
    }
  }

  function monkeyPatchAddEventListener() {
    const original = EventTarget.prototype.addEventListener;
    EventTarget.prototype.addEventListener = function (type, listener, options) {
      if (
        this.matches &&
        this.matches('[aria-controls*="cart"], a[href="/cart"]') &&
        (type === "click" || type === "keydown")
      ) {
        console.log(`${LOG_PREFIX} Blocked theme drawer listener`);
        return;
      }
      return original.call(this, type, listener, options);
    };
  }

  // === Global fallback click catch for ANY cart-related trigger
  function globalCartTriggerListener(e) {
    const cartIntentSelectors = [
      '[href="/cart"]',
      '[aria-controls*="cart"]',
      '[data-action="open-cart"]',
      '[data-cart-trigger]',
      '[data-drawer-id="cart"]',
      '.cart-toggle', '.cart-link', '.header__icon--cart', '.drawer-cart-toggle',
      '[data-drawer-open="cart"]'
    ];

    const target = e.target.closest(cartIntentSelectors.join(','));
    if (target) {
      e.preventDefault();
      e.stopPropagation();
      console.log(`${LOG_PREFIX} Global fallback detected cart trigger`);
      openCartDrawer();
    }
  }

  function observeDOM() {
    new MutationObserver(() => {
      hijackCartActions();
      enforceAriaExpandedFalse();
    }).observe(document.body, { childList: true, subtree: true });
  }

  function startOverlaySweeper() {
    function sweep() {
      clearThemeDrawerArtifacts();
      requestAnimationFrame(sweep);
    }
    requestAnimationFrame(sweep);
  }

  document.addEventListener("DOMContentLoaded", () => {
    console.log(`${LOG_PREFIX} Init`);
    hijackCartActions();
    observeDOM();
    nullifyShopifyEvents();
    enforceAriaExpandedFalse();
    startOverlaySweeper();
    setTimeout(monkeyPatchAddEventListener, 0);

    // NEW: universal fallback listener
    document.addEventListener("click", globalCartTriggerListener, true);
  });
})();
